//import { createContext } from 'react';
import { COMPANY_NAME_FULL, COMPANY_NAME_SHORT } from "../common";
import { DONATION_MIN_AMOUNT, DONATION_MAX_AMOUNT } from "../common/constant";

export const PaymentContext = {
    secondaryUserData: {
    },
    cause: {
        donationAmount: 0.00,
        frequency: 'one time',
        entity: 'individual',
        id: '',
        causes: COMPANY_NAME_FULL + ' (' + COMPANY_NAME_SHORT + ')',
        default: {
            donationAmount: 0.00,          // default donation amount
            frequency: 'one time',           // yearly
            entity: 'individual',           // individual | corporate
            id: '',
            causes: COMPANY_NAME_FULL + ' (' + COMPANY_NAME_SHORT + ')',
            minAmount: DONATION_MIN_AMOUNT,                // minimum donation amount
            maxAmount: DONATION_MAX_AMOUNT,           // maximum donation amount
        }
    },
    campaign: {
        donationAmount: 0.00,
        frequency: 'one time',
        entity: 'individual',
        id: '',                             // selected campaign id(s)
        default: {
            donationAmount: 0.00,          // default donation amount
            frequency: 'one time',           // yearly
            entity: 'individual',           // individual | corporate
            id: '',                         // default campaign name(s)
            minAmount: DONATION_MIN_AMOUNT,                // minimum donation amount
            maxAmount: DONATION_MAX_AMOUNT,           // maximum donation amount
        }
    },
    patron: {
        donationAmount: 0.00,
        frequency: 'one time',
        entity: 'individual',
        id: 0,                             // selected campaign id(s)
        default: {
            donationAmount: 0.00,        // default donation amount
            frequency: 'one time',           // one time | recurrent
            entity: 'individual',           // individual | corporate
            id: 0,                         // default campaign name(s)
            minAmount: DONATION_MIN_AMOUNT,             // minimum donation amount
            maxAmount: DONATION_MAX_AMOUNT,           // maximum donation amount
        }
    },
    adoptartwork: {
        donationAmount: 0.0,
        frequency: 'one time',
        partPayment: '',
        entity: 'individual',
        artworkName: "Artwork Name",         // selected cause name(s)
        programName: "",
        id: 0,                             // selected campaign id(s)
        privilegeid: 0,
        causes: ["Innovation and  Experimentation"],
        default: {
            donationAmount: 0.0,        // default donation amount
            frequency: 'one time',           // one time | recurrent
            partPayment: '',                // monthly | quarterly | annually
            entity: 'individual',           // individual | corporate
            name: 'Artwork Name',            // default cause name
            id: 0,                         // default campaign name(s)
            minAmount: 0.0,             // minimum donation amount
            maxAmount: 200000.00,           // maximum donation amount
            causes: ["Innovation and  Experimentation"],   // default cause name(s)
        }
    },
    paymentDetails: {
        transactionNo: '',
        cardTokenId: '',
        cardId: '',
        fingerprint: '',
        isUserRegistered: '',
        isPatronMember: ''
    },
    donationMethod: 'cause',                // cause | campaign | adoptartwork | patron
    navLinkRef: null,
    referrer: '',
    isScrolling: false,
    isLearnMore: false,
    setNavActiveInactive: function (exception) {
        let children = this.navLinkRef?.current ? this.navLinkRef.current.childNodes : null;
        if (children) {
            children.forEach(item => {
                if (!exception) {
                    item.classList.remove('active');
                } else {
                    if (item.innerText.trim().toUpperCase() === exception.replace('-', ' ').toUpperCase()) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                }
            });
        }
    },
    resetValues: function (method) {
        let donationMethod = this[method];
        let objDefault = donationMethod['default'];
        for (let key in objDefault) {
            donationMethod[key] = objDefault[key];
        }
    },
    scrollTo: function (param, top) {
        let offset = true;
        let ele = document.getElementById(param);
        if (ele) {
            if (document.body.offsetWidth <= 1024) { offset = false; }
            document.body.scrollTop = param.toUpperCase() === 'HOME' ? 0 : (typeof top === 'number') ? top : (ele.offsetTop - (offset ? this.navLinkRef.current.offsetHeight : 100));
            this.setNavActiveInactive(param.toUpperCase());

        } else if (typeof param === 'number') {
            document.body.scrollTop = param;
        } else {
            document.body.scrollTop = 0;
            if (param) {
                this.setNavActiveInactive(param);
            } else {
                this.setNavActiveInactive();
            }
        }
        this.referrer = '';
    },
}